import React, { FunctionComponent } from 'react';

import { Dispatch } from 'redux';
import { connect } from 'react-redux';

import moment from 'moment';

import { Translate } from 'react-localize-redux';

import styled from 'styled-components';

import { CloseMenu } from '@webapp/store/ui/action-creators';

//Components
import Menu from '@components/menu';
import Box from '@components/layout/box';
import Flex from '@components/layout/flex';
import Typography from '@components/basics/typography';
import CloseIcon from '@components/basics/icons/close';
import DotsCircleIcon from '@components/basics/icons/dots-circle';
import { TourEvent } from '@common/types/traclink/tour-event';
import EditTour from '@webapp/controllers/artist/artist-tour/edit-tour';

interface TourItemProps {
  className?: string;
  tour: TourEvent;
  closeMenu: () => CloseMenu;
  onEditEvent: (tourEvent: TourEvent) => void;
  onDeleteEvent: (tourId: string) => void;
  onStartEditEvent: (tourId: string) => void;
  onCancelEditEvent: () => void;
  isEdit: boolean;
  loading: boolean;
}

const mapDispatchToProps = (dispatch: Dispatch) => ({
  closeMenu: () => dispatch(new CloseMenu()),
});

const TourItem: FunctionComponent<TourItemProps> = ({
  className,
  tour,
  closeMenu,
  onStartEditEvent,
  onCancelEditEvent,
  onEditEvent,
  onDeleteEvent,
  isEdit = false,
  loading,
}) => {
  return (
    <Box className={className || ''}>
      {isEdit ? (
        <EditTour
          loading={loading}
          tour={tour}
          onEdit={onEditEvent}
          onCancel={onCancelEditEvent}
        />
      ) : (
        <>
          <Flex
            className="first-line"
            justifyContent="space-between"
            alignItems="center"
          >
            <Typography weight="700">{tour.title}</Typography>
            <Menu
              className="menu"
              button={<DotsCircleIcon className="open-icon" />}
              closeButton={
                <CloseIcon onClick={closeMenu} className="close-icon" />
              }
              customIconHeight="24px"
              menuId={`ARTIST-TOUR-MENU-${tour.id}`}
            >
              <MenuContent>
                <Typography
                  weight="700"
                  className="menu-item"
                  onClick={() => onStartEditEvent(tour.id)}
                >
                  <Translate id="ARTIST_PROFILE.PROFILE.SUBITEM.GENERAL.TOUR.MENU.EDIT" />
                </Typography>
                <Typography
                  weight="700"
                  className="menu-item danger"
                  onClick={() => onDeleteEvent(tour.id)}
                >
                  <Translate id="ARTIST_PROFILE.PROFILE.SUBITEM.GENERAL.TOUR.MENU.DELETE" />
                </Typography>
              </MenuContent>
            </Menu>
          </Flex>
          <Flex justifyContent="space-between" alignItems="center">
            <Typography className="secondary-text" type="small">
              {tour.place}
            </Typography>
            <Typography className="secondary-text" type="small" align="right">
              {moment(tour.dateTime).format('MM/DD/YY')}
            </Typography>
          </Flex>
        </>
      )}
    </Box>
  );
};

export default connect(
  null,
  mapDispatchToProps
)(styled(TourItem)`
  background-color: ${({ theme }) => theme.colors.differentBackground};

  .first-line {
    margin-bottom: 24px;
    ${({ theme }) => `@media screen and ${theme.device.tablet}`} {
      margin-bottom: 40px;
    }
  }

  .menu {
    .open-icon,
    .close-icon {
      width: 24px;
      height: 24px;
      cursor: pointer;
    }
  }

  .secondary-text {
    color: ${({ theme }) => theme.colors.tertiary};
  }
`);

const MenuContent = styled.div`
  display: grid;
  grid-gap: 5px;
  min-width: 128px;

  .menu-item {
    cursor: pointer;
    transition: color
      ${({ theme }) =>
        `${theme.transitions.duration} ${theme.transitions.type}`};

    &:hover {
      color: ${({ theme }) => theme.colors.tertiary};
    }

    &.danger {
      color: ${({ theme }) => theme.colors.accent};
      margin-top: 14px;
      &:hover {
        color: ${({ theme }) => theme.colors.accentHover};
      }
    }
  }
`;
